export default {
	purchaseProposalForm: require("./purchase-proposal-form").default,
	purchaseProposalFormPrint: require("./purchase-proposal-form-print").default,
};
